import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class UniversalInterceptor implements HttpInterceptor {
  constructor(private keycloakService: KeycloakService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let serverReq: HttpRequest<unknown> = req;


    if (this.keycloakService.isLoggedIn()) {
      serverReq = serverReq.clone({
        setHeaders: {
          Authorization: `Bearer ${this.keycloakService.getKeycloakInstance()?.token}`
        }
      });
    }


    return next.handle(serverReq)
      .pipe(
        tap({
          error: (err: HttpErrorResponse) => {
          if (err.url.indexOf('Quotation') > -1 || err.url.indexOf('ProductPurchase') > -1) {
            if (err.status === 500 || err.status === 404 || err.status === 502) {
             /* TODO setTimeout(()=>{
                this.state.go('Funnel.ErrorPage');
              },200);*/
            }
          } else if(err.url.indexOf('CleanCacheData?cachePart=All') > -1){
            if (err.status === 404) {
              // TODO this.state.go(this.genericService.viewRoot() + '.ContentPage', {slugPath: '/'},{reload: true});
             // TODO DOCUMENT document.location.reload();
            }
          } else if(err.url.indexOf('GetCacheData') > -1){
            if (err.status === 404) {
              // TODO this.state.go(this.genericService.viewRoot() + '.ContentPage', {slugPath: '/'},{reload: true});
             // TODO DOCUMENT document.location.reload();
            }


          }

          else {
            if (err.status === 401 && !req.url.includes('Profile')) {
              //TODO this.state.go(this.genericService.viewRoot() + '.ContentPage', {slugPath: '/'});
            }

              if (err.status === 401 && err.url.includes('PrivateArea')) {
                this.keycloakService.login();
            }

            if (err.status === 401 && err.url.indexOf('UserAccount') >= 0) {
             /* TODO if (this.state.current.name !== this.genericService.viewRoot() + '.AreaRiservata.RedirectToLogin') {
                const stateName = this.state.current.name;
                const stateParam = this.state.current.params?.tab;
                this.genericService.storePreviousLink(stateName, stateParam);
              }*/
              //this.state.go(this.genericService.viewRoot() + '.ContentPage', {slugPath: '/area-riservata/login'});
            }
          }
          },
        })
      )
  }
}
